import IconMap from './iconMap';

const CustomIcon = ({ type }) => {
  // Ensure type uses the correct icon name format
  const iconName = `Icon${type.charAt(0).toUpperCase()}${type.slice(1)}`;
  return IconMap[iconName] || null;
};

export default CustomIcon;